<template>
  <div class="waitlist-modal">
    <!-- Success -->
    <appear v-if="success">
      <div class="header mt-4 py-5">
        <img class="mail-icon" src="@/assets/icons/mail.svg" alt="mail envelope" />
        <h3 class="header-lg font-black mt-3 mb-4">You're signed up!</h3>
        <p class="px-3 font-large">
          Check your inbox weekly for new available properties in {{ market.displayName }}. You can
          <a class="blue-80--txt underline" :href="unsubscribeURL" target="_blank"> unsubscribe</a>
          at anytime.
        </p>
        <b-btn class="my-4" variant="dark" @click="closeModal">Continue</b-btn>
      </div>
    </appear>

    <!-- Default -->
    <template v-else>
      <div class="header">
        <img class="mail-icon" src="@/assets/icons/mail.svg" alt="mail envelope" />
        <h3 class="header-lg font-black mb-3">Get New Listings</h3>
        <p v-limit="300" class="mx-auto font-large">
          Get notified when new properties hit the market
        </p>
      </div>

      <validation-observer ref="form" v-slot="{ invalid }">
        <form>
          <b-row>
            <!-- First Name -->
            <b-col sm="6">
              <form-input
                type="text"
                name="firstName"
                label="First name"
                v-model="form.firstName"
                validation="required|name|max:128"
              />
            </b-col>
            <!-- Last Name -->
            <b-col sm="6">
              <form-input
                type="text"
                name="lastName"
                label="Last name"
                v-model="form.lastName"
                validation="required|name|max:128"
              />
            </b-col>
            <!-- Email -->
            <b-col>
              <form-input
                type="email"
                name="email"
                label="Email address"
                v-model="form.email"
                validation="required|email"
              />
            </b-col>
          </b-row>
        </form>
        <div class="text-center">
          <p :class="['form-helper-text', { visible: invalid }]">All fields required</p>
          <b-button
            v-limit="250"
            variant="gradient"
            class="w-100 mx-auto"
            @click.once="onSubmit"
            :disabled="invalid"
            >Submit</b-button
          >
        </div>
      </validation-observer>
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { get } from 'lodash-es'

export default {
  name: 'WaitListForm',
  props: {
    market: {
      type: Object,
      required: true,
    },
    homeType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      success: false,
      form: {
        firstName: '',
        lastName: '',
        email: '',
      },
    }
  },
  created() {
    this.form.email = get(this.activeUser, 'email', '')
  },
  mounted() {
    this.$segment.track('Modal Opened', {
      location: 'Get New Listings',
    })
  },
  computed: {
    unsubscribeURL() {
      return `https://bungalow.com/unsubscribe?email=${this.form.email}`
    },
  },
  methods: {
    ...mapActions('funnel', ['createOrUpdateDemandLead']),
    closeModal() {
      setTimeout(() => {
        this.$root.$emit('closeModal')
      }, 250)
    },
    onSubmit() {
      this.$refs.form.validate().then((isValid) => {
        if (isValid) {
          this.createOrUpdateDemandLead({
            lead: this.form,
            homeType: this.homeType,
            query: this.$route.query,
            marketDisplayName: this.market.displayName,
            intentLevel: 'market',
          })
        }
      })

      this.success = true
    },
  },
}
</script>

<style lang="scss">
.waitlist-modal {
  .header {
    text-align: center;
    padding-top: 1.25rem;
    padding-bottom: 1rem;

    .mail-icon {
      width: 4rem;
      height: 4rem;
      margin-bottom: 1rem;
    }
  }
}
</style>
